<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button
          class="mr10"
          type="primary"
          size="small"
          @click="addSignInActivity"
          >添加签到规则</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="keyWords"
          placeholder="请输入规则名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          size="small"
          class="mr10"
          style="width: 170px;"
          clearable
          v-model="actType"
          placeholder="请选择规则类型"
        >
          <el-option label="每日签到" value="1"></el-option>
          <el-option label="累计签到" value="2"></el-option>
          <el-option label="连续签到" value="3"></el-option>
          <el-option label="节假日签到" value="4"></el-option>
        </el-select>
        <el-select
          size="small"
          class="mr10"
          style="width: 170px;"
          clearable
          v-model="actStatus"
          placeholder="请选择开启状态"
        >
          <el-option label="开启" value="true"></el-option>
          <el-option label="关闭" value="false"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="hm-radio-group">
      <el-radio-group v-model="dateFlag" size="small" @change="switchTab">
        <el-radio-button label="0"
          >全部({{ stateCount.timeType0 }})</el-radio-button
        >
        <el-radio-button label="1">
          未开始({{ stateCount.timeType1 }})
        </el-radio-button>
        <el-radio-button label="2">
          进行中({{ stateCount.timeType2 }})
        </el-radio-button>
        <el-radio-button label="3"
          >已结束({{ stateCount.timeType3 }})</el-radio-button
        >
      </el-radio-group>
    </div>
    <div class="table">
      <el-table
        border
        stripe
        ref="roleTable"
        :data="activityCenterList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="编号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="signedName"
          label="规则名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          prop="signedType"
          label="规则类型"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.signedType === '1'">每日签到</span>
            <span v-if="scope.row.signedType === '2'">累计签到</span>
            <span v-if="scope.row.signedType === '3'">连续签到</span>
            <span v-if="scope.row.signedType === '4'">节假日签到</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="signedPriority"
          label="规则优先级"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.signedPriority === '1'">高</span>
            <span v-if="scope.row.signedPriority === '2'">中</span>
            <span v-if="scope.row.signedPriority === '3'">低</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="signedStartday"
          label="开始时间"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.signedStartday }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="signedEndday"
          label="结束时间"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.signedEndday }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="是否开启"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.enabledState === 'true'" class="success"
              >开启</span
            >
            <span v-else class="danger">关闭</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="复制" placement="top">
                <button class="pointer mr10 no-bg" @click="copy(scope.row)">
                  <span class="hmicon icon-fuzhi blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                class="item"
                content="查看"
                placement="top"
                v-if="scope.row.gameType !== 'collect_card'"
              >
                <button
                  class="pointer mr10 no-bg"
                  @click="toDetails(scope.row)"
                >
                  <span class="hmicon icon-chakan blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="编辑" placement="top">
                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top" v-if="scope.row.isCanDel">
                <div
                  class="pointer mr10"
                  @click="remove(scope.row)"
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="activityCenterList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total,sizes,  prev, pager, next, jumper, sizes"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      keyWords: "",
      isOutputing: false,
      actType: "",
      actStatus: "",
      pageSize: 10,
      currentPage: 1,
      stateCount: {},
      dateFlag: "0"
    };
  },
  computed: mapGetters(["activityCenterList", "activityCenterAllList"]),
  watch: {
    "activityCenterList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          this.queryList();
        }
      },
      deep: true
    }
  },
  created() {
    const echoParams = getCookie({ key: "ACTLIST", type: "session" });
    if (echoParams) {
      for (let key in echoParams) {
        if (this.hasOwnProperty(key)) {
          this[key] = echoParams[key];
        }
      }
      if (echoParams.startDate && echoParams.endDate) {
        this.date = [
          new Date(echoParams.startDate),
          new Date(echoParams.endDate)
        ];
      }
      // this.currentPage = echoParams.pageNo;
    }
  },
  mounted() {
    this.getParamsCookie();
    this.queryCount();
    this.queryList();
  },
  methods: {
    copy(row) {
      this.$router.push({
        name: "AddSignInActivity",
        query: {
          signedActivityId: row.signedActivityId
        }
      });
    },
    toDetails(row) {
      this.$router.push({
        name: "SignInActivityDetails",
        query: {
          signedActivityId: row.signedActivityId,
          signedType: row.signedType
        }
      });
    },
    async queryCount() {
      const { result } = await this.$store.dispatch(
        "querySignedActivityTimeTypeCount"
      );
      this.stateCount = result;
    },
    queryList() {
      this.setParamsCookie();
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        keyWords: this.keyWords,
        signedType: this.actType,
        enabledState: this.actStatus,
        timeType: this.dateFlag
      };
      setCookie({
        key: "ACTLIST",
        type: "session",
        data: params
      });
      return this.$store.dispatch("queryActivityCenterList", params);
    },
    setParamsCookie() {
      let searchCondition = {
        keyWords: this.keyWords,
        actType: this.actType,
        actStatus: this.actStatus,
        dateFlag: this.dateFlag
      };
      setCookie({
        key: "signInActivityParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "signInActivityParams", type: "session" });
      if (prams) {
        this.keyWords = prams.keyWords;
        this.actType = prams.actType;
        this.actStatus = prams.actStatus;
        this.dateFlag = prams.dateFlag;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      const params = {
        pageSize: 999999,
        pageNo: 1,
        keyWords: this.keyWords,
        signedType: this.actType,
        enabledState: this.actStatus,
        timeType: this.dateFlag
      };
      return this.$store.dispatch("queryActivityCenterAllList", params);
    },
    switchTab(val) {
      this.currentPage = 1;
      this.dateFlag = val;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    addSignInActivity() {
      this.$router.push({
        name: "AddSignInActivity"
      });
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("delSignedActivityInfo", {
            signedActivityId: row.signedActivityId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    edit(row) {
      this.$router.push({
        name: "EditSignInActivity",
        query: {
          signedActivityId: row.signedActivityId
        }
      });
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(() => {
            const list = this.activityCenterAllList.records;
            list.forEach(v => {
              if (v.signedPriority == "1") {
                v.signedPriority = "高";
              } else if (v.signedPriority == "2") {
                v.signedPriority = "中";
              } else if (v.signedPriority == "3") {
                v.signedPriority = "低";
              }
              if (v.enabledState == "true") {
                v.enabledState = "开启";
              } else if (v.enabledState == "false") {
                v.enabledState = "关闭";
              }
              if (v.signedType == "1") {
                v.signedType = "每日签到";
              } else if (v.signedType == "2") {
                v.signedType = "累计签到";
              } else if (v.signedType == "3") {
                v.signedType = "连续签到";
              } else if (v.signedType == "4") {
                v.signedType = "节假日签到";
              }
            });

            const tHeader = [
              "规则名称",
              "规则类型",
              "规则优先级",
              "开始时间",
              "结束时间",
              "是否开启"
            ];
            const filterVal = [
              "signedName",
              "signedType",
              "signedPriority",
              "signedStartday",
              "signedEndday",
              "enabledState"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "签到列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
